export const CREATE_DOCUMENT_BANK_MUTATION = `
  mutation CreateDocumentBank(
    $companyId: Int!
    $title: String!
    $description: String
    $createdBy: Int!
    $category: String
    $process: String
    $isActive: Boolean
  ) {
    insert_document_bank_one(object: {
      company_id: $companyId
      title: $title
      description: $description
      created_by: $createdBy
      category: $category
      process: $process
      is_active: $isActive
    }) {
      id
      title
      created_at
    }
  }
`;

export const UPDATE_DOCUMENT_BANK_MUTATION = `
  mutation UpdateDocumentBank(
    $id: uuid!
    $title: String!
    $description: String
    $category: String
    $process: String
    $isActive: Boolean
  ) {
    update_document_bank_by_pk(
      pk_columns: { id: $id }
      _set: {
        title: $title
        description: $description
        category: $category
        process: $process
        is_active: $isActive
      }
    ) {
      id
      title
      description
      updated_at
    }
  }
`;

// Aktif/Pasif toggle icin ayri mutation — sadece is_active alanini gunceller.
export const TOGGLE_DOCUMENT_BANK_ACTIVE_MUTATION = `
  mutation ToggleDocumentBankActive($id: uuid!, $isActive: Boolean!) {
    update_document_bank_by_pk(
      pk_columns: { id: $id }
      _set: { is_active: $isActive }
    ) {
      id
      is_active
    }
  }
`;

export const DELETE_DOCUMENT_BANK_MUTATION = `
  mutation DeleteDocumentBank($id: uuid!) {
    delete_document_bank_by_pk(id: $id) {
      id
    }
  }
`;

export const CREATE_DOCUMENT_BANK_VERSION_MUTATION = `
  mutation CreateDocumentBankVersion(
    $documentId: uuid!
    $versionNumber: Int!
    $fileUrl: String!
    $fileName: String!
    $fileSize: bigint
    $mimeType: String
    $notes: String
    $uploadedBy: Int!
  ) {
    insert_document_bank_versions_one(object: {
      document_id: $documentId
      version_number: $versionNumber
      file_url: $fileUrl
      file_name: $fileName
      file_size: $fileSize
      mime_type: $mimeType
      notes: $notes
      uploaded_by: $uploadedBy
    }) {
      id
      version_number
      file_name
      uploaded_at
    }
  }
`;

export const REPLACE_DOCUMENT_BANK_ASSIGNMENTS_MUTATION = `
  mutation ReplaceDocumentBankAssignments(
    $documentId: uuid!
    $objects: [document_bank_assignments_insert_input!]!
  ) {
    delete_document_bank_assignments(
      where: { document_id: { _eq: $documentId } }
    ) {
      affected_rows
    }
    insert_document_bank_assignments(objects: $objects) {
      affected_rows
      returning {
        id
        assignment_type
        assignment_ref_id
      }
    }
  }
`;

// Bir dokumanin tum etiket atamalarini sil ve yeniden ekle (tam replace).
// objects bos array olabilir — bu tum etiketlerin kaldirildigi anlamina gelir.
export const REPLACE_DOCUMENT_BANK_TAG_ASSIGNMENTS_MUTATION = `
  mutation ReplaceDocumentBankTagAssignments(
    $documentId: uuid!
    $objects: [document_bank_tag_assignments_insert_input!]!
  ) {
    delete_document_bank_tag_assignments(
      where: { document_id: { _eq: $documentId } }
    ) {
      affected_rows
    }
    insert_document_bank_tag_assignments(objects: $objects) {
      affected_rows
      returning {
        id
        tag_id
      }
    }
  }
`;

// Etiket CRUD (Ayarlar sayfasi). useDynamicEntity pattern'i: create -> $object,
// update -> $id + $set. Bkz. tags.js.
export const CREATE_DOCUMENT_BANK_TAG_MUTATION = `
  mutation CreateDocumentBankTag($object: document_bank_tags_insert_input!) {
    insert_document_bank_tags_one(object: $object) {
      id
      name
      color
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const UPDATE_DOCUMENT_BANK_TAG_MUTATION = `
  mutation UpdateDocumentBankTag($id: Int!, $set: document_bank_tags_set_input!) {
    update_document_bank_tags_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      name
      color
      company_id
      company {
        id
        name
      }
      updated_at
    }
  }
`;

export const DELETE_DOCUMENT_BANK_TAG_MUTATION = `
  mutation DeleteDocumentBankTag($id: Int!) {
    delete_document_bank_tags_by_pk(id: $id) {
      id
    }
  }
`;
